import { apiSlice, defaultTransformFn } from 'api/apiSlice'
import { AIPlanPreview } from 'api/entities/AIPlanPreview'

const BASE_URL = 'aiPlans'

const aiPlansTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['AIPlan']
})

export const aiPlansApi = aiPlansTags.injectEndpoints({
  endpoints: builder => ({
    getAIPlan: builder.query<AIPlanPreview, { publicId: string }>({
      query: ({ publicId }) => ({
        url: `${BASE_URL}/${publicId}`,
        method: 'GET',
        isContext: true,
        isAgency: false
      }),
      providesTags: (_result, _error, request) => [{ type: 'AIPlan', id: request.publicId }],
      transformResponse: defaultTransformFn
    })
  })
})

export const { useGetAIPlanQuery } = aiPlansApi
